import type { ReactNode } from 'react'
import { Children, Fragment } from 'react'

export interface EnumerateProps {
  children: ReactNode
  /**
   * if provided, will override any separator logic
   */
  separator?: string

  /**
   * If `false` (default), omits the "and" before the last item (simply joins with commas).
   * If `true`, uses "and" before the last item (Oxford comma style for 3+, just "and" for 2).
   *
   * @default false
   */
  shouldUseFinalAnd?: boolean
}

export function Enumerate({
  children,
  separator,
  shouldUseFinalAnd = false,
}: EnumerateProps) {
  const items = Children.toArray(children)

  return (
    <Fragment>
      {items.map((child, index) => {
        const isLast = index === items.length - 2
        const isOxfordComma = items.length > 2 && isLast

        return (
          // oxlint-disable-next-line react/no-array-index-key
          <Fragment key={index}>
            {child}
            {index < items.length - 1 ? (
              <span className="whitespace-pre">
                {separator ??
                  (isOxfordComma && shouldUseFinalAnd
                    ? `, and `
                    : items.length === 2 && shouldUseFinalAnd
                      ? ` and `
                      : `, `)}
              </span>
            ) : null}
          </Fragment>
        )
      })}
    </Fragment>
  )
}
